import React, { PureComponent } from "react";
import { compose } from "redux";
import { Field } from "redux-form/immutable";
import { Grid, MenuItem } from "@material-ui/core";

import { BasePageTitle } from "altus-ui-components";

import TextField from "app/components/form/TextField";
import ReadOnlyField from "app/components/form/ReadOnlyField";
import { SUB_CONTRACTOR_COMPANY_FORM } from "features/planner/planner.constants";
import { required } from "utils/validation.util";

class SubContractorCompanyForm extends PureComponent {
  render() {
    const { companies } = this.props;

    return (
      <Grid
        container
        direction="column"
        item
        xs={12}
        lg={6}
        style={{
          display: "block",
        }}
      >
        <Grid item>
          <BasePageTitle title="Company" />
        </Grid>
        <Grid item xs>
          <Field
            select
            required
            validate={[required]}
            label="Company"
            component={TextField}
            name={SUB_CONTRACTOR_COMPANY_FORM.COMPANY_ID}
          >
            {companies.map(company => (
              <MenuItem value={company.get("id")} key={company.get("id")}>
                {company.get("name")}
              </MenuItem>
            ))}
          </Field>
        </Grid>
        <Grid item xs>
          <Field
            label="Contact E-mail"
            defaultValue="-"
            component={ReadOnlyField}
            name={SUB_CONTRACTOR_COMPANY_FORM.CONTACT_EMAIL}
          />
        </Grid>
        <Grid item xs>
          <Field
            defaultValue="-"
            label="Duty Phone"
            component={ReadOnlyField}
            name={SUB_CONTRACTOR_COMPANY_FORM.DUTY_PHONE}
          />
        </Grid>
        <Grid container>
          <Field
            rows={5}
            multiline
            label="Notes"
            component={ReadOnlyField}
            name={SUB_CONTRACTOR_COMPANY_FORM.NOTES}
          ></Field>
        </Grid>
      </Grid>
    );
  }
}

export default compose()(SubContractorCompanyForm);
